import thumb from '../../../assets/images/devcareer/thumb.png';
import full01 from '../../../assets/images/devcareer/full01.png';
import full02 from '../../../assets/images/devcareer/full02.png';
import full03 from '../../../assets/images/devcareer/full03.png';
import full04 from '../../../assets/images/devcareer/full04.png';
import full05 from '../../../assets/images/devcareer/full05.png';
import full06 from '../../../assets/images/devcareer/full06.png';

const devcareerData = {
  name: 'DevCareer Website V2',
  description: `The second version of DevCareer's official website.`,
  skills: ['SCSS', 'Bootstrap4', 'Gatsby'],
  sources: [
    { caption: 'Home | DevCareer', source: full01 },
    { caption: 'Home | DevCareer', source: full02 },
    { caption: 'Support | DevCareer', source: full03 },
    { caption: 'Home | DevCareer', source: full04 },
    { caption: 'About | DevCareer', source: full05 },
    { caption: 'Mobile Navbar | DevCareer', source: full06 },
  ],
  thumbnail: thumb,
  liveUrl: 'https://devcareer.io/',
};

export default devcareerData;
